<template>
  <div>
    <el-dialog :title="$t('message.editPassword')" :visible.sync="dialogVisible" width="600px" center
      :close-on-click-modal="false">
      <div class="content">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm"
          label-position="top">
          <el-form-item label="您的手机号：">
            <el-input v-model="mobile" readonly></el-input><el-button type="primary" @click="sendAdminUpdatePwdCode"
              :disabled="!show">{{ show ? '获取验证码' : Countdown + '秒后发送' }}</el-button>
          </el-form-item>
          <el-form-item label="您收到的验证码：" prop="code">
            <el-input v-model="ruleForm.code"></el-input>
          </el-form-item>
          <el-form-item label="请输入您的新密码：" prop="newPwd">
            <el-input v-model="ruleForm.newPwd" type="password" autocomplete="off" show-password></el-input>
          </el-form-item>
          <el-form-item label="请再输入一次：" prop="newPwdRepet">
            <el-input v-model="ruleForm.newPwdRepet" type="password" autocomplete="off" show-password></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="updatePwd">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    var validatePass2 = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm.newPwd) {
        callback(new Error("输入密码和前一次输入的不一致"));
      } else {
        callback();
      }
    };
    return {
      dialogVisible: false,
      mobile: localStorage.getItem("japanUserRoleInfo") ? JSON.parse(localStorage.getItem("japanUserRoleInfo")).mobile : '',
      ruleForm: {},
      rules: {
        tel: [
          {
            required: true,
            message: "请输入手机号",
            trigger: ["blur", "change"],
          },
        ],
        code: [
          {
            required: true,
            message: "请输入验证码",
            trigger: ["blur", "change"],
          },
        ],
        newPwd: [
          {
            required: true,
            min: 6, max: 16,
            message: "请输入 6 到 16 位的密码,不支持空格",
            trigger: ["blur", "change"],
          },
        ],
        newPwdRepet: [
          {
            required: true,
            validator: validatePass2,
          },
        ],
      },
      Countdown: 60,
      show: true,
    };
  },
  methods: {
    sendAdminUpdatePwdCode() {
      this.show = false;
      this.Countdown = 60;
      this.show = true;
      // 60秒倒计时
      this.show = false;
      var timer = setInterval(() => {
        this.Countdown--;
        if (this.Countdown <= 0) {
          this.show = true;
          this.Countdown = 60;
          clearInterval(timer);
        }
      }, 1000);
      this.$api.roleApi.sendAdminUpdatePwdCode().then(res => {
        this.$message.success('已发送验证码')
      })
    },
    updatePwd() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.$api.roleApi.updatePwd(this.ruleForm).then(res => {
            this.$message.success('修改成功，请重新登录')
            this.$parent.logOut()
          })

        }
      })
    }
  },
  watch: {
    dialogVisible() {
      this.ruleForm = {}
    }
  }
}
</script>
<style lang='scss' scoped>
.content {
  padding: 0 50px;

  /deep/.el-form-item {
    margin: 5px;

    .el-form-item__content {
      display: flex;
    }
  }

  /deep/.el-form-item__label {
    margin: 0;
    padding: 0;
  }
}
</style>